(function (ws) {
    'use strict';
    ws.views.savedCartsLink = Backbone.View.extend({
        events: {
            click: 'onClick'
        },

        /**
         * Initialize.
         */
        initialize() {
            this.$savedCartCount = this.$el.find('.cartCount');
            this.savedCartCount = parseInt(this.$savedCartCount.text());
            this.eventAgg.on('saveCart', this.onSaveCart.bind(this));
        },

        /**
         * Called when a cart is saved;
         * updates the number of saved carts.
         *
         * @param {Object} data
         * @param {int} data.savedCartCount
         */
        onSaveCart(data) {
            this.savedCartCount = data.savedCartCount;
            this.render();
        },

        /**
         * Renders the component.
         */
        render() {
            this.$savedCartCount.text(this.savedCartCount);
            this.enable(this.savedCartCount > 0);
        },

        /**
         * Ignores clicks when the component is disabled.
         *
         * @param {MouseEvent} e
         */
        onClick(e) {
            if (this.isDisabled()) {
                e.preventDefault();
            }
        },

        /**
         * Gets whether or not the component is disabled.
         *
         * @return {boolean}
         */
        isDisabled() {
            return this.$el.hasClass('disabled');
        },

        /**
         * Enables or disables the component.
         *
         * @param {boolean} isEnabled
         */
        enable(isEnabled) {
            if (isEnabled) {
                this.$el.removeClass('disabled');
            }
            else {
                this.$el.addClass('disabled');
            }
        }
    });
})(westcon);
